import { render } from "./ProjectPageVideoContainer.vue?vue&type=template&id=b456d960"
import script from "./ProjectPageVideoContainer.vue?vue&type=script&lang=js"
export * from "./ProjectPageVideoContainer.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Website/Website/front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__